import * as Constants from "./constants";
/**
 * Actions pour la gestion de l'utilisateur connecté
 * @category Store
 * @hideconstructor
 */

var ConnectedUserStoreAction = /*#__PURE__*/function () {
  function ConnectedUserStoreAction() {}

  /**
   * Mise à jour des données de l'utilisateur connecté
   * @param {object} user Les données de l'utilisateur connecté
   */
  ConnectedUserStoreAction.setConnectedUser = function setConnectedUser(user) {
    return {
      type: Constants.SET_CONNECTED_USER,
      value: user
    };
  }
  /**
   * RAZ des informations de l'utilisateur connecté
   */
  ;

  ConnectedUserStoreAction.resetConnectedUser = function resetConnectedUser() {
    return {
      type: Constants.SET_CONNECTED_USER,
      value: null
    };
  };

  return ConnectedUserStoreAction;
}(); // Exports


export var resetConnectedUser = ConnectedUserStoreAction.resetConnectedUser;
export var setConnectedUser = ConnectedUserStoreAction.setConnectedUser;